module.exports = __webpack_public_path__ + "46dd44143c39dbce225661e3c47ab4d5.svg";